import React, { useState, useEffect } from 'react'

import { Link } from "react-router-dom"

import { PHOTOS_ROOT, AVATAR_ROOT, WEBROOT } from '../constants/general'

import Func from '../class/Func'

import User from '../class/User'

import Moment from 'react-moment'
import 'moment/locale/fr'

import Discussions from '../class/Discussions'

const HeaderProfile = () => {

    const [infos, setInfos] = useState(false)

    const myInfos = async () => {

        let results = await User.session(true)

        if (results.success) {

            setInfos(results.data)

        }

    }

    const copierLien = () => {

        const text = 'https://sistersgreen.fr/profile/' + localStorage.getItem('idU')

        var textField = document.createElement('textarea')
        textField.innerText = text
        document.body.appendChild(textField)
        textField.select()
        document.execCommand('copy')
        textField.remove()

        alert('Lien profil copié')

    }

    useEffect(() => {

        myInfos()

    }, [])

    return (

        <>

            <div className='m_flex flex ai-center'>

                <a href="#" className='cl2 textUnd fz09'>Profil</a>

                <span className='cur_p' title='Copier lien profil' onClick={() => copierLien()}><img src='/image/share.svg' /></span>

            </div>

            <div className="bg7 br8 p20 mt20">
                <div className="flex pos-r">

                    <div className="flex m_flex">
                        <div className="av large mr40">

                            <img src={Func.avatar(infos.avatar)} className="avatar_img" />

                        </div>

                        <div className='m_col-7 m_ml_15'>
                            <div className="flex m_flex ai-center fz09 prfl flex-wrap flex-start">

                                <span className='t cl2 fw5 m_col_10'>{infos.name}</span>

                                {Func.note(infos.note)} <span className='ml10'>( {infos.nbr_note} avis</span>)

                            </div>

                            <div className="flex jc-start mt20 m_mt_10 ai-center">
                                <span className="icon mr10 fz13">i</span>
                                <span className='h'>{infos.pays}{infos.ville != null ? ', ' + infos.ville : "Localisation"}</span>
                            </div>

                            <div className='mt20 m_mt_10'>

                                <span>Informations vérifiées :</span>

                                <ul>
                                    {infos.email_token == 0 && <li>Email</li>}
                                    {infos.charte_green == 1 && <li className='cl2'><Link to={'/page/la-chartegreen'} className='cl2'>Charte Green signée</Link></li>}
                                </ul>

                            </div>

                        </div>

                    </div>

                    <div>

                        {

                            infos.charte_green == 0

                            &&

                            <Link to={'/mon-profile/signer-charte-green'} className="btn cl1 bg4 ta-center d-block mb10 m_mt_10 pulse">Signer la charte Green</Link>

                        }

                    </div>

                </div>

            </div>

        </>
    )

}

const ProfileMenu = (props) => {

    let not_active = "btn cl2 bgt mr10"
    let active = "btn brc4 brc2solid cl1 bg4 mr10"

    return (
        <div className="wrap textUp fw5 mb20 m_profile_menu">
            <Link to={'/mon-profile/articles'} className={props.data == 'articles' ? active : not_active}>Pépinière</Link>
            <Link to={'/mon-profile/evaluations'} className={props.data == 'evaluations' ? active : not_active}>évaluations</Link>
            {/* <Link to={'/mon-profile/plant-sitting'} className={props.data == 'plant-sitting' ? active : not_active }>Plant-sitting</Link> */}
            <Link to={'/mon-profile/parametres'} className={props.data == 'parametres' ? active : not_active}>Paramètres</Link>
            <Link to={'/mon-profile/transactions'} className={props.data == 'transactions' ? active : not_active}>Transactions</Link>
            <Link to={'/mon-profile/paiements'} className={props.data == 'paiements' ? active : not_active}>Paiements</Link>
            <Link to={'/mon-profile/porte-monnaie'} style={{ background: '#D43A72' }} className='btn cl1'>Porte-Monnaie</Link>
        </div>
    )

}

const Article = (props) => {

    return (
        <Link to={'/annonce/' + props.data.idA} className="article bg6 cl2">
            <div className="img">
                <img src={PHOTOS_ROOT + 'small/' + props.data.name + ".jpg"} />
            </div>
            <div className="cnt">
                <div className="flex m_flex">
                    <span className='price'>{props.data.prix}€</span>
                    {/* <span className='fz08'>{props.data.nbr_favoris} favoris</span> */}
                    {props.data.stt == 1 && <span className='fz09 cl3 fw5'>Vendu</span>}
                    {props.data.stt == 2 && <span className='fz09 cl3 fw5'>Vendu</span>}
                    {props.data.stt == 3 && <span className='fz09 cl3 fw5'>Vendu</span>}
                    {props.data.stt == 5 && <span className='fz09 cl3 fw5'>Masqué</span>}
                </div>
                <span className='t h mt20'>{props.data.titre}</span>
            </div>
        </Link>
    )

}

const DiscussionsCard = (discussion_id) => {

    const [discussions, setDiscussions] = useState(false)

    const mesDiscussions = async () => {

        let results = await Discussions.mes_discussions({ limit: 12 })

        if (results.success) {

            setDiscussions(results.data)

        } else {

            setDiscussions(results.message)

        }

    }

    useEffect(() => {

        mesDiscussions()

    }, [])

    return (
        <div className='col-3 bg7 br8 p20 discussions'>

            <h2 className='mb20'>Mes discussions</h2>

            {

                discussions

                    ?

                    typeof discussions == 'object'

                        ?

                        discussions.map(element => <DiscussionCard data={element} discussion_id={discussion_id.discussion_id} key={element.id} />)

                        :

                        <p className='fz08'>{discussions}</p>

                    :

                    <div className='flex jc-center mt50 mb50'>
                        <div className="lds-dual-ring col"></div>
                    </div>

            }

        </div>
    )

}

const DiscussionCard = (props) => {

    const me = localStorage.getItem('idU')

    const discussionClick = (id) => {

        let elem = document.querySelector('#discussion_' + id)

        elem.classList.remove('fw7')

        if (elem.querySelector('.badge')) elem.querySelector('.badge').remove()

    }

    let badge = ''

    if (me == props.data.u1) {

        if (props.data.new_u1 > 0) badge = <span className='badge'>{props.data.new_u1}</span>

    } else {

        if (props.data.new_u2 > 0) badge = <span className='badge'>{props.data.new_u2}</span>

    }

    let class_name = '';

    if (badge == '') {

        class_name = 'discussion'

    } else {

        class_name = 'discussion fw7'

    }

    if (props.data.id == props.discussion_id) class_name += ' active'

    return (

        <Link to={"/mon-profile/discussion/" + props.data.id} className={class_name} id={'discussion_' + props.data.id} onClick={() => discussionClick(props.data.id)}>

            <img src={Func.avatar(props.data.avatar)} />

            <div style={{ overflow: 'hidden' }}>
                <p className='text_long'>{props.data.name} {badge}</p>
                <span className="t">{props.data.type == 'ps' && <img src="/image/icon-arrosage.svg" style={{ width: '18px', height: '18px', borderRadius: 0, marginRight: '5px' }} />} <Moment interval='1000' locale="fr" fromNow>{props.data.date}</Moment></span>
            </div>

        </Link>

    )

}

const Message = (props) => {

    const me = localStorage.getItem('idU')

    const id = props.id
    const annonce_id = props.annonce_id
    const msg = props.data
    const mode_envoi = props.mode_envoi

    const opt = JSON.parse(msg.opt)

    let montant = (parseFloat(opt.montant) + 0.98 + parseFloat(opt.montant) * 0.05)

    const [ajuster, setAjuster] = useState(false)

    const refuser = async (e) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, 'refuser')

        if (results.success) {

            Func.envoyeMessageBox("J'ai refusé cette offre")

        } else {

            alert(results.message)

        }

    }

    const accepter = async (e) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, 'accepter')

        if (results.success) {

            Func.envoyeMessageBox("J'ai accepté cette offre")

        } else {

            alert(results.message)

        }

    }

    const livrer = async (e) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, 'envoyer')

        if (results.success) {

            Func.envoyeMessageBox("J'ai envoyé le colis")

        } else {

            alert(results.message)

        }

    }

    const misere = async (e) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, 'misere')

        if (results.success) {

            Func.envoyeMessageBox("J'ai une misère !")

        } else {

            alert(results.message)

        }

    }

    const finaliser = async (e) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, 'finaliser')

        if (results.success) {

            // Func.envoyeMessageBox("J'ai finaliser cette vente, Je donne mon avis sur le vendeur <a href='/mon-profile/ajouter_avis/"+ results.message_id +"'>Ajouter un avis</a>")
            Func.envoyeMessageBox("Transaction finalisée.")

        } else {

            alert(results.message)

        }

    }

    const annuler = async (e) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, 'annuler')

        if (results.success) {

            Func.envoyeMessageBox("J'ai annulé cette vente.")

        } else {

            alert(results.message)

        }

    }

    const ps_refuser = async (e) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, 'ps_refuser')

        if (results.success) {

            Func.envoyeMessageBox("J'ai refusé cette demande")

        } else {

            alert(results.message)

        }

    }

    const ps_accepter = async (e) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, 'ps_accepter')

        if (results.success) {

            Func.envoyeMessageBox("J'ai accepté cette demande")

        } else {

            alert(results.message)

        }

    }

    const ps_ajuster = async (e) => {

        e.preventDefault()

        const input = e.target

        if (input.offre.value == '') return

        let results = await Discussions.repondre_message(id, msg.i, 'ps_ajuster', input.offre.value)

        if (results.success) {

            input.parentNode.remove()

            Func.envoyeMessageBox("J'ai ajusté cette demande")

        } else {

            alert(results.message)

        }

    }

    const ps_annuler = async (e, message_type) => {

        e.target.parentNode.remove()

        let results = await Discussions.repondre_message(id, msg.i, message_type)

        if (results.success) {

            Func.envoyeMessageBox("J'ai annulé cette demande")

        } else {

            alert(results.message)

        }

    }

    const ps_demarrer = async (e) => {

        let results = await Discussions.repondre_message(id, msg.i, 'ps_demarrer')

        if (results.success) {

            e.target.parentNode.remove()

            Func.envoyeMessageBox("J'ai démarré cette demande")

        } else {

            alert(results.message)

        }

    }

    return (

        <div className={me == msg.s ? 'message bg9 p10 br8 col-8 ml20per m_col-8' : 'message bg7 p10 br8 col-8 m_col-8'}>

            <div className={me == msg.s ? 'flex flex-reverse' : 'flex'}>
                <div className='user'>
                    <div className="av">
                        <img src={Func.avatar(msg.avatar)} />
                    </div>
                    <Link to={'/profile/' + msg.s} className="t cl2">{msg.name}</Link>
                </div>
                <span className='fz08'><Moment interval='1000' locale="fr" fromNow>{msg.date}</Moment></span>
            </div>

            {

                msg.type == 1 && msg.s == me && msg.stt == 0

                &&

                <div className='pt20'>
                    <span className='btn bg4 cl1 mr10'>Acheter</span>
                </div>

            }

            {

                msg.type == 2 && msg.s != me

                &&

                <>

                    <div className='cnt mt20'>

                        <p className='mb10'>Coucou, je te fais une offre</p>
                        <p className='mb10 fw6'>{opt.offre} €</p>

                    </div>


                    {

                        msg.stt == 0

                            ?

                            <div>
                                <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => accepter(e)}>J'accepte</span>
                                <span className='btn brc4 brc2solid cl4 hover-cl1 hover-bg4' onClick={(e) => refuser(e)}>Je refuse</span>
                            </div>

                            :

                            msg.stt == 1

                                ?

                                <span>Accepté</span>

                                :

                                <span>Refusé</span>

                    }

                </>

            }

            {

                msg.type == 2 && msg.s == me

                &&

                <div className='cnt mt20'>

                    <p className='mb10'>Tu as fait une offre pour cet article</p>
                    <p><span className='fw6'>{opt.offre} €</span>

                        {

                            msg.stt == 0

                                ?

                                <span> En attente</span>

                                :

                                msg.stt == 1

                                    ?

                                    <span> Accepté</span>

                                    :

                                    <span> Refusé</span>

                        }

                    </p>

                </div>

            }

            {

                msg.type == 3

                &&

                <div className='cnt'>

                    <p>{msg.msg}</p>

                </div>

            }

            {

                // Acheteur

                msg.type == 4 && msg.s != me

                &&

                <div className='cnt mt20'>

                    <p>Le vendeur a refusé ton offre. Tu peux toujours acheter l'article au prix initial</p>

                </div>

            }

            {

                // Vendeur

                msg.type == 4 && msg.s == me

                &&

                <div className='cnt'>

                    <p>J'ai refusé cette offre</p>

                </div>

            }

            {

                // Acheteur

                msg.type == 5 && msg.s == me

                &&

                <>

                    <div className='cnt'>

                        <p>Patiente pour le paiement</p>

                    </div>

                </>

            }

            {

                // Vendeur

                msg.type == 5 && msg.s != me && msg.stt == 0

                &&

                <>

                    <div className='cnt mt20'>

                        <p>Maintenant, tu peux acheter cet article</p>

                    </div>

                    <div className='pt20'>
                        <Link to={'/commander?annonce=' + annonce_id + '&offre=' + msg.i} className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4'>J'achète</Link>
                    </div>

                </>

            }

            {

                // Vendeur

                msg.type == 5 && msg.s != me && msg.stt == 1

                &&

                <>

                    <div className='cnt mt20'>

                        <p>Offre acceptée</p>

                    </div>

                </>

            }

            {

                // Coté vendeur - achat

                msg.type == 6 && msg.s != me && (msg.stt == 0 || msg.stt == 1 || msg.stt == 2)

                &&

                <>

                    <div className='cnt pt20'>

                        <p className='d-block mb20 fw6'>{opt.montant} €</p>

                        {

                            opt.lot != undefined

                                ?

                                <div className='mb10 d-block'>
                                    <p className='mb10'>Tu as vendu un lot avec les articles suivants :</p>
                                    <p className='mb20 cl4 fw6'>{msg.msg}</p>
                                </div>

                                :

                                <p className='mb10 d-block'>Ton article est vendu, l’acheteur a réglé les frais de port.</p>

                        }

                        <p className='mb20 d-block fz12'><Link to={opt.etiquette_url} className='cl4 fw6 underline' target="_blank">Je télécharge le bordereau d'envoi</Link></p>
                        <p className='mb20 d-block fz08 cl3'>Tu as 7 jours pour envoyer la lettre/colis et cliquer sur "J'ai envoyé le colis". Sans action de ta part, même si le colis a été envoyé, la transaction sera annulée et une évaluation négative sera ajoutée à ton compte.</p>

                        <p className='mb10 d-block'>J'imprime l'étiquette <strong>Plante Vivante</strong>.</p>

                        {
                            (mode_envoi == 'colis' || mode_envoi == 'enveloppe')

                            &&
                            <>
                                <p className='mb10 d-block'>1. Si je dépose le colis / lettre suivie à la Poste, j’informe l’acheteur en cliquant sur le bouton <strong>J'ai envoyé le colis</strong>.</p>
                                <p className='mb10 d-block'>2. Si je dépose le colis dans ma boîte aux lettres, je dois me référer aux informations indiquées sur le bordereau d'envoi.</p>
                                <p className='mb30 d-block'>En cas de non-dépôt du colis dans la boîte aux lettres, tu as la possibilité de reprogrammer un autre passage avec le <Link to={'https://www.laposte.fr/expedition-bal/formulaire'} target='blank' className='cl4'><strong>formulaire en ligne</strong></Link>, dès qu'il est pris en charge, je clique sur le bouton <strong>J'ai envoyé le colis</strong>.</p>
                            </>
                        }

                        {/* {
                            mode_envoi == 'mondial_relay'

                            &&
                            <>
                                <p className='mb10 d-block'>1. Je dépose le colis dans un point relais, j’informe l’acheteur en cliquant sur le bouton J'ai envoyé le colis.</p>
                                <p className='mb10 d-block'>2. Trouve ton <Link to={'https://www.mondialrelay.fr/trouver-le-point-relais-le-plus-proche-de-chez-moi/'} target='blank' className='cl4'><strong>Point Relais® ou Locker</strong></Link></p>
                            </>
                        } */}

                        <p className='mb10 d-block fz08'>Je consulte la <Link to={'/page/faq-livraison'} target='_blank' className='cl4'><strong>FAQ Livraison</strong></Link> pour plus de détails sur L’envoi en boîte aux lettres.</p>

                    </div>

                    <div className='pt20 flex ai-center m_flex m_f_wrap mb10'>
                        <p className='flex-end fz08 mr10'>Payé le <Moment format='DD/MM/YYYY \à HH:mm' className='ml5'>{msg.date}</Moment></p>
                        {msg.stt == 0 && <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4 m_mt_10 m_mb_10' onClick={(e) => livrer(e)}>J'ai envoyé le colis</span>}
                    </div>
                </>

            }

            {

                // Coté vendeur - achat - Vente annulée

                msg.type == 6 && msg.s != me && msg.stt == 2

                &&

                <>

                    <div className='cnt pt20'>

                        <p className='mb10 d-block'>La vente est annulée car l'article n'a pas été envoyé, tu recevras une évaluation automatique négative.</p>

                    </div>

                </>

            }

            {

                // Coté acheteur - achat

                msg.type == 6 && msg.s == me && (msg.stt == 0 || msg.stt == 1 || msg.stt == 2)

                &&

                <>
                    <div className='cnt pt20'>
                        <p className='d-block'><span className='fw6'>{opt.montant} €</span> <span className='fz09'>Hors frais de livraison</span></p>
                        <p className='fz09 mb20 d-block cl4'><span className='fw6 fz11'>{montant.toFixed(2)} €</span> Frais de service inclus</p>

                        <p className='mb10'>Félicitations, tu viens de faire un geste pour la planète</p>

                        {
                            opt.lot != undefined

                            &&

                            <div className='mb10 d-block'>
                                <p className='mb10'>Nous avons informé le vendeur que tu as craqué pour plusieurs de ses articles.</p>
                            </div>

                        }

                        <p className='mb10'>Maintenant, patiente que le vendeur envoie le colis</p>

                    </div>

                    <p className='flex-end fz08'>Paiement effectué, En attente de l'envoi du colis par le vendeur.</p>
                </>

            }

            {

                // Coté acheteur - achat - Vente annulée

                msg.type == 6 && msg.s == me && msg.stt == 2

                &&

                <>

                    <div className='cnt pt20'>

                        <p className='mb10 d-block'>Ta commande est annulée car elle n'a pas été envoyée.</p>
                        {/* <p className='mb10 d-block'>Un remboursement sera effectué sur ton compte bancaire.</p> */}

                    </div>

                </>

            }

            {/* Colis envoyé ------------------------------------------------------------------ */}
            {/* Colis envoyé ------------------------------------------------------------------ */}
            {/* Colis envoyé ------------------------------------------------------------------ */}

            {

                // Colis envoyé vendeur

                msg.type == 7 && msg.s == me

                &&

                <>
                    <p className='mb10'>Colis envoyé le <Moment format='DD/MM/YYYY \à HH:mm'>{msg.date}</Moment></p>
                    <p className='mb10'>Tu peux suivre le colis en cliquant sur ce lien</p>

                    {
                        mode_envoi == 'colis' || mode_envoi == 'enveloppe'
                            ?
                            <p><Link to={'https://www.laposte.fr/outils/suivre-vos-envois'} target='_blank'>https://www.laposte.fr/outils/suivre-vos-envois</Link></p>
                            :
                            <p><Link to={'https://www.mondialrelay.fr/suivi-de-colis/'} target='_blank'>https://www.mondialrelay.fr/suivi-de-colis/</Link></p>
                    }

                </>

            }

            {

                // Colis envoyé acheteur

                msg.type == 7 && msg.s != me

                &&

                <>
                    <div className='mt20'>
                        <p className='mb10'>Ta commande a été expédiée, tu peux suivre le colis en cliquant sur ce lien

                            {
                                (mode_envoi == 'colis' || mode_envoi == 'enveloppe')
                                    ?
                                    <Link to={'https://www.laposte.fr/outils/suivre-vos-envois'} target='_blank'> https://www.laposte.fr/outils/suivre-vos-envois</Link>
                                    :
                                    <Link to={'https://www.mondialrelay.fr/suivi-de-colis/'} target='_blank'> https://www.mondialrelay.fr/suivi-de-colis/</Link>
                            }

                        </p>
                        <p className='mb30'>Délivre au plus vite ta plante afin de lui présenter sa nouvelle maison et la chouchouter ! Tu as 4 jour pour récupérer le colis, sinon il sera automatiquement renvoyé vers le vendeur.</p>

                        <p className='mb10'>1. Si l’article est conforme à sa description, je le confirme en appuyant sur sur le bouton <strong>Tout est OK</strong> et permettre au vendeur de recevoir son paiement.</p>
                        <p className='mb10'>2. Si l’article n’est pas conforme à sa description, endommagé lors du transport ou qu’il manque un article dans le lot, j’informe le vendeur en appuyant sur le bouton <strong>J’ai une misère</strong>, je garde toutes les preuves en ma possession et je donne les informations au vendeur.</p>
                        <p className='mb10'>3. Si {(mode_envoi == 'colis' || mode_envoi == 'enveloppe') ? 'La poste' : 'Mondial Relay'} m’informe que le colis est perdu, j’informe le vendeur pour qu’il prenne contact avec le service Sisters Green.</p>
                    </div>

                    {

                        msg.stt == 0

                        &&

                        <div className='pt20 flex-end ai-center'>
                            <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => finaliser(e)} title="Finaliser la vente">Tout est OK</span>
                            <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => misere(e)} title="J'ai un problème avec le produit">J'ai une misère</span>
                            {/* <Link to={'/traking/' + opt.livraison_label} className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' target="_blank" title='Traking de votre colis'>Traking</Link> */}
                        </div>

                    }

                </>

            }

            {

                // Colis envoyé acheteur / Cliqué

                msg.type == 7 && msg.s != me && msg.stt == 1

                &&

                <>

                    <div className='mt20'>
                        <p>Ta commande a été livré</p>
                    </div>

                </>

            }

            {/* Vente finalisée ------------------------------------------------------------------ */}
            {/* Vente finalisée ------------------------------------------------------------------ */}
            {/* Vente finalisée ------------------------------------------------------------------ */}

            {

                // Acheteur 

                msg.type == 8 && msg.s == me && msg.stt == 0

                &&

                <>
                    <div>
                        <p className='mt20'>Raconte nous comment s’est passé ta transaction avec le vendeur</p>
                    </div>

                    <div className='pt20 flex-end ai-center'>
                        <Link to={'/mon-profile/ajouter_avis/' + msg.i} className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4'>Je laisse mon évaluation</Link>
                    </div>
                </>

            }

            {

                // Acheteur 

                msg.type == 8 && msg.s == me && msg.stt == 1

                &&

                <>
                    <div>
                        <p className='mt20'>J'ai laissé mon évaluation</p>
                    </div>

                </>

            }

            {

                // Vendeur

                msg.type == 8 && msg.s != me

                &&

                <>

                    <div>
                        <p className='mt20 mb10'>L'article a bien été reçu</p>
                        <p>Les gains de la vente seront bientôt transférés sur ton porte-monnaie. Vas sur ton profil Sisters Green et assure-toi que ton RIB soit à jour dans la section "PORTE-MONNAIE "</p>
                    </div>

                    {

                        // Acheteur 

                        msg.type == 8 && msg.s != me && msg.stt == 1

                        &&

                        <>
                            <div>
                                <p className='mt20 mb20 cl4'>Tu as reçu une nouvelle évaluation, découvre la !</p>
                            </div>

                        </>

                    }

                    <p className='flex-end fz08'>vente finalisée le <Moment format=' DD/MM/YYYY \à HH:mm' className='ml5'>{msg.date}</Moment></p>

                </>

            }

            {

                // Vente annulée

                // Vendeur 

                msg.type == 9 && msg.s == me

                &&

                <>
                    <div>
                        <p className='mt20'>Transaction annulée</p>
                    </div>

                </>

            }

            {

                // Vente annulée

                // Acheteur 

                msg.type == 9 && msg.s != me

                &&

                <>
                    <div>
                        <p className='mt20'>Un remboursement sera effectué sur ta carte de paiement.</p>
                    </div>

                </>

            }

            {

                // Misère : Acheteur

                msg.type == 10 && msg.s == me

                &&

                <>

                    <div className='mt20'>
                        <p>Une misère est arrivée avec cet article, nous te suggérons de trouver une solution amiable avec le membre Sisters Green concerné par cette transaction. Si les deux parties ne trouvent aucun accord, elles doivent contacter l’adresse mail dédiée aux litiges entre utilisateurs litige@sistersgreen.fr dans les 10 jours à compter d'aujourd'hui. Pas d'inquiétude, tu seras contacté dans les plus brefs délais</p>

                        {

                            msg.stt == 0

                            &&

                            <div className='pt20 flex-end ai-center'>
                                <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => finaliser(e)} title="Finaliser la vente">Je n'ai plus de misère, tout est OK</span>
                            </div>

                        }

                    </div>

                </>

            }

            {

                // Misère : Vendeur

                msg.type == 10 && msg.s != me

                &&

                <>

                    <div className='mt20'>
                        <p>Une misère est arrivée avec cet article, nous te suggérons de trouver une solution amiable avec l'acheteur.</p>

                        {

                            msg.stt == 0

                            &&

                            <>

                                <p className='mt30'>1. Si l’article n’est pas conforme à sa description, endommagé lors du transport ou qu’il manque un article dans le lot, je procède à l’annulation de la transaction en appuyant sur le bouton <strong>J’annule la transaction</strong> ou bien je propose l’envoi d’une autre plante à mes frais, cela permettra à l’acheteur de finaliser la vente.</p>
                                <p className='mt10'>2. Si l’acheteur m’informe que le colis est perdu, je dois m’en assurer auprès de {(mode_envoi == 'colis' || mode_envoi == 'enveloppe') ? 'La poste' : 'Mondial Relay'} et j’informe Sisters Green via : litige@sistersgreen.fr</p>
                                <p className='mt10'>3. Si les deux parties ne trouvent aucun accord, elles doivent contacter l’adresse mail dédiée aux litiges.</p>

                                <p className='mt30 fz09'>Notre priorité est la bonne réputation de la communauté Sisters Green et celle de nos vendeurs</p>

                                <p className='mt10 fz09'>Aucun retour de produit n'est possible</p>

                                <div className='pt20 flex-end ai-center'>
                                    <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => annuler(e)} title="Finaliser la vente">J'annule la transaction</span>
                                </div>

                            </>

                        }

                    </div>

                </>

            }

            {

                // Discussion Plant sitting ------------------------------------------------------
                // Discussion Plant sitting ------------------------------------------------------
                // Discussion Plant sitting ------------------------------------------------------

            }

            {

                // Réserver : Acheteur

                (msg.type == 30 && msg.s == me)

                &&

                <>

                    <div className='mt20'>

                        {opt.categorie == 1 && <p className='fz12'><strong>Ta demande de gardiennage est envoyée !</strong></p>}
                        {opt.categorie == 2 && <p className='fz12'><strong>Ta demande d'arrosage est envoyée !</strong></p>}
                        {opt.categorie == 3 && <p className='fz12'><strong>Ta demande de Jardinage est envoyée !</strong></p>}

                        <p className='mt10 mb10'>Voici les détails de la mission :</p>

                        <p className='mb5'>Date d’intervention souhaitée : du <strong><Moment format='DD/MM/YYYY'>{opt.date_debut}</Moment></strong> au <strong><Moment format='DD/MM/YYYY'>{opt.date_fin}</Moment></strong></p>
                        
                        {opt.lieu && <p className='mb5'>Adresse approximative : <strong>{opt.lieu}</strong></p>}
                        {opt.taille && <p className='mb5'>Taille du jardin : <strong>{opt.taille} m²</strong></p>}
                        {opt.type && <p className='mb5'>Type d'arrosage : <strong>{opt.type}</strong></p>}



                        {

                            (opt.categorie == 1 || opt.categorie == 2)

                            &&

                            <p className='mb5'>Nombre de plantes :
                                {opt.reservation == 1 && <strong> Entre 1 & 30 plantes</strong>}
                                {opt.reservation == 2 && <strong> Supérieur 30 plantes</strong>}
                            </p>

                        }

                        {

                            opt.categorie == 3

                            &&

                            <p className='mb5'>Type de prestation :
                                {opt.reservation == 1 && <strong> Tondre</strong>}
                                {opt.reservation == 2 && <strong> Tailler</strong>}
                                {opt.reservation == 3 && <strong> Nettoyer et autre</strong>}
                            </p>

                        }

                        {opt.logement && <p className='mb5'>Type de logement : <strong>{opt.logement}</strong></p>}
                        <p className='mb5'>Nombre de jours : <strong>{opt.nbrjours} jours</strong></p>
                        <p className='mb20'>Tarif ajustable : <strong>{opt.prix_total} €</strong> ({(parseFloat(opt.prix_total) - parseFloat(opt.prix)).toFixed(2)} € frais de service)</p>
                        <p><strong>Description détaillée</strong> : {opt.description}</p>

                        <p className='mt20 fz08'><strong>Besoin d’envoyer plus d’infos ?</strong></p>
                        <p className='fz08'>N’hésite pas à contacter l’utilisateur via la messagerie interne et lui rajouter des informations nécessaires, attends qu’il accepte ta demande pour passer au paiement et valider la transaction.</p>

                    </div>

                </>

            }

            {

                // Réserver : Prestataire

                (msg.type == 30 && msg.s != me)

                &&

                <>

                    <div className='mt20'>

                        {opt.categorie == 1 && <p className='fz12'><strong>Nouvelle demande de gardiennage reçue !</strong></p>}
                        {opt.categorie == 2 && <p className='fz12'><strong>Nouvelle demande d'arrosage reçue !</strong></p>}
                        {opt.categorie == 3 && <p className='fz12'><strong>Nouvelle demande de Jardinage reçue !</strong></p>}

                        <p className='mt10 mb10'>Voici les détails de la mission :</p>

                        <p className='mb5'>Date d’intervention souhaitée : du <strong><Moment format='DD/MM/YYYY'>{opt.date_debut}</Moment></strong> au <strong><Moment format='DD/MM/YYYY'>{opt.date_fin}</Moment></strong></p>
                        
                        {/* {opt.categorie == 1 && <p className='mb5'>Adresse prestataire : <strong>{annonces.ville}</strong></p>} */}

                        {opt.lieu && <p className='mb5'>Adresse approximative : <strong>{opt.lieu}</strong></p>}
                        {opt.taille && <p className='mb5'>Taille du jardin : <strong>{opt.taille} m²</strong></p>}
                        {opt.type && <p className='mb5'>Type d'arrosage : <strong>{opt.type}</strong></p>}



                        {

                            (opt.categorie == 1 || opt.categorie == 2)

                            &&

                            <p className='mb5'>Nombre de plantes :
                                {opt.reservation == 1 && <strong> Entre 1 & 30 plantes</strong>}
                                {opt.reservation == 2 && <strong> Supérieur 30 plantes</strong>}
                            </p>

                        }

                        {

                            opt.categorie == 3

                            &&

                            <p className='mb5'>Type de prestation :
                                {opt.reservation == 1 && <strong> Tondre</strong>}
                                {opt.reservation == 2 && <strong> Tailler</strong>}
                                {opt.reservation == 3 && <strong> Nettoyer et autre</strong>}
                            </p>

                        }

                        {opt.logement && <p className='mb5'>Type de logement : <strong>{opt.logement}</strong></p>}
                        <p className='mb5'>Nombre de jours : <strong>{opt.nbrjours} jours</strong></p>
                        <p className='mb20'>Tarif ajustable : <strong>{opt.prix} €</strong></p>
                        <p><strong>Description détaillée</strong> : {opt.description}</p>

                        <div className='fz08'>
                            <p className='mt20'><strong>Besoin d’envoyer plus d’infos ?</strong></p>
                            <p>N’hésite pas à contacter l’utilisateur pour poser tes questions avant de confirmer ou ajuster le tarif, sinon il sera obligé de refaire une autre réservation.</p>

                            <p className='mt20'><strong>Que souhaites-tu faire ?</strong></p>
                            <p>L’utilisateur est en attente de ta réponse. Pour maximiser tes chances d’être choisi, nous te recommandons de répondre dans les plus brefs délais.</p>
                        </div>

                        {

                            msg.stt == 0

                            &&

                            <>

                                <div className='pt20 flex-end ai-center'>
                                    <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => ps_refuser(e)}>Refuser</span>
                                    <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => ps_accepter(e)}>Accepter</span>
                                    <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={() => setAjuster(true)}>Ajuster</span>

                                    {

                                        ajuster

                                        &&

                                        <div className='mask2'>

                                            <form className='gla-form popup bg1 col-3 p40 br10 pos-r' onSubmit={(e) => ps_ajuster(e)} id="form_offre">

                                                <h2 className='mb20'>Ajuster le prix</h2>

                                                <hr />

                                                <div className='pt10'>

                                                    <input type="number" name="offre" defaultValue={opt.prix} step="0.1" min={2} required={true} style={{ width: '100%' }} />

                                                </div>

                                                <hr className='mb10' />

                                                <input type="submit" value='Ajuster' className='btn brc4 brc2solid cl1 bg4 ta-center' />

                                                <span className='exit btn cl4 icon' onClick={e => setAjuster(false)}>w</span>

                                            </form>

                                        </div>

                                    }

                                </div>

                            </>

                        }

                    </div>

                </>

            }

            {

                // Refusé : Acheteur

                (msg.type == 32 && msg.s == me)

                &&

                <>

                    <div className='mt20'>

                        <p className='mt10 mb10'>Demande refusée</p>

                    </div>

                </>

            }

            {

                // Refusé : Prestataire

                (msg.type == 32 && msg.s != me)

                &&

                <>

                    <div className='mt20'>

                        <p className='mt10 mb10'>Le plantsitter/jardinier a refusé ta demande</p>

                    </div>

                </>

            }

            {

                // Accepté : Acheteur --- et Ajusté Acheteur

                ((msg.type == 33 || msg.type == 31) && msg.s != me)

                &&

                <>

                    <div className='mt20'>

                        <p className='mb10 fw5 fz11'>Bonne nouvelle ! Ta demande a été acceptée.</p>

                        {msg.type == 31 && <p className='mb10 fz13'>Un ajustement de tarif est proposé : <strong>{opt.prix} €</strong></p>}

                        <p className='mb10'>Ton jardinier ou plant-sitter est prêt(e) à s’occuper de tes plantes ou de ton jardin, selon les conditions convenues.</p>
                        <p>Pour finaliser la réservation, <strong>clique sur Payer</strong>. Une fois le paiement effectué, vous pourrez échanger vos adresses et toutes les informations pratiques directement via la messagerie.</p>
                        <p className='cl3 mt10'>Pas d’inquiétude : le montant reste sécurisé et ne sera versé au prestataire qu’à la fin de l’intervention.</p>

                        {

                            msg.stt == 0

                            &&

                            <>

                                <div className='pt20 flex-end ai-center'>
                                    <Link to={'/payer?reservation=' + msg.i} className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4'>Payer</Link>
                                </div>

                            </>

                        }

                    </div>

                </>

            }

            {

                // Accepté : Prestataire

                (msg.type == 33 && msg.s == me)

                &&

                <>

                    <div className='mt20'>

                        <p className='mt10 mb10'>Demande acceptée</p>

                    </div>

                </>

            }

            {

                // Ajusté : Prestataire

                (msg.type == 31 && msg.s == me)

                &&

                <>

                    <div className='mt20'>

                        <p className='mt10 mb10'>J'ai ajusté la demande, tarif ajusté : <strong>{opt.prix} €</strong></p>

                    </div>

                </>

            }

            {

                // Payé : Client

                (msg.type == 34 && msg.s == me)

                &&

                <>

                    <div className='mt20'>

                        <p className='mb10 fw5 fz11'>Merci pour ta réservation !</p>

                        <p className='fz09 mb30'>Le paiement a bien été effectué et sécurisé jusqu’à la fin de la prestation. Tu peux désormais échanger avec ton plant-sitter / jardinier pour lui transmettre toutes les infos utiles (adresse, accès, instructions).</p>

                        <p className='mb20'>Date d’intervention : du <strong><Moment format='DD/MM/YYYY'>{opt.date_debut}</Moment></strong> au <strong><Moment format='DD/MM/YYYY'>{opt.date_fin}</Moment></strong></p>

                        {

                            (new Date(opt.date_debut) < new Date())

                            &&

                            <>
                                <p className='mb10 fw5 fz11'>Le moment est venu de lancer la mission !</p>

                                <p className='fz09 mb10'>Si ton prestataire est bien arrivé et/ou prêt(e) à intervenir, clique sur « <strong>Démarrer</strong> » en sa présence.</p>

                                <p className='fz09 mb10'>Cela permet d’officialiser le démarrage du service et d’activer le suivi de la prestation.</p>

                                <p className='fz09'>Si ton prestataire est absent ou n’a pas respecté la date de début, clique sur « <strong>Annuler</strong> », un remboursement partiel du montant de la prestation sera déclenché conformément à nos conditions d'utilisation.</p>

                            </>

                        }

                    </div>

                    {

                        msg.stt == 0 && (new Date(opt.date_debut) < new Date())

                        &&

                        <>

                            <div className='pt20 flex-end ai-center'>
                                <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => ps_demarrer(e)}>Démarrer</span>
                                <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => ps_annuler(e, 'ps_annuler_client')}>Annuler</span>
                            </div>

                        </>

                    }

                </>

            }

            {

                // Payé : Prestataire

                (msg.type == 34 && msg.s != me)

                &&

                <>

                    <div className='mt20'>

                        <p className='mb10 fw5 fz11'>Bonne nouvelle ! L’utilisateur a confirmé la réservation.</p>

                        <p className='fz09 mb10'>Le paiement a bien été effectué et les fonds sont désormais sécurisés : ils te seront versés à la fin de l’intervention. Tu peux maintenant échanger directement avec l’utilisateur via la messagerie pour obtenir son adresse et les informations pratiques. Merci de prendre soin de ses plantes ou de son jardin comme convenu !</p>

                        <p className='mb20'>Date d’intervention : du <strong><Moment format='DD/MM/YYYY'>{opt.date_debut}</Moment></strong> au <strong><Moment format='DD/MM/YYYY'>{opt.date_fin}</Moment></strong></p>

                        <p className='cl3 mb20'>Pour que la mission soit officiellement lancée, le client doit cliquer sur « Démarrer » en ta présence le jour prévu.</p>

                        <p className='fw5'>Information importante : En cas d'annulation, une évaluation négative automatique sera ajoutée à ton profil.</p>

                    </div>

                    {

                        msg.stt == 0

                        &&

                        <>

                            <div className='pt20 flex-end ai-center'>
                                <span className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4' onClick={(e) => ps_annuler(e, 'ps_annuler_prestataire')}>Annuler</span>
                            </div>

                        </>

                    }

                </>

            }

            {

                // Annuler : Client

                (msg.type == 35 && msg.s == me)

                &&

                <>

                    <div className='mt20'>

                        <p>Réservation annulée, un remboursement partiel sera effectué sur ta carte.</p>

                    </div>

                </>

            }

            {

                // Annuler : Prestataire

                (msg.type == 35 && msg.s != me)

                &&

                <>

                    <div className='mt20'>

                        <p>L'utilisateur a annulé la réservation.</p>

                    </div>

                </>

            }

            {

                // Annuler : Client

                (msg.type == 36 && msg.s != me)

                &&

                <>

                    <div className='mt20'>

                        <p className='mb10'>Nous sommes désolés, ton plant-sitter / jardinier a annulé la prestation après confirmation.</p>

                        <p>Pas d’inquiétude : ton paiement reste sécurisé — un remboursement intégral est en cours de traitement.</p>

                    </div>

                </>

            }

            {

                // Annuler : Prestataire

                (msg.type == 36 && msg.s == me)

                &&

                <>

                    <div className='mt20'>

                        <p>Réservation annulée.</p>

                    </div>

                </>

            }

            {

                // Démarrer : Client / Prestataire

                msg.type == 37

                &&

                <>

                    <div className='mt20'>

                        <p className='mb10 fw5'>C’est parti ! L’intervention a bien démarré. </p>
                        <p>Le paiement restera sécurisé jusqu’à la fin de l’intervention, conformément à notre politique de protection.</p>

                    </div>

                </>

            }

            {

                // Finalisé : Client

                (msg.type == 38 && msg.s == me)

                &&

                <>
                    <div>
                        <p className='mt20 mb10 fw5'>Transaction finalisée !</p>
                        {msg.stt == 0 && <p>Il est temps de laisser une évaluation à ton jardinier / plant-sitter pour partager ton expérience.</p>}
                    </div>

                    {

                        msg.stt == 0

                        &&

                        <div className='pt20 flex-end ai-center'>
                            <Link to={'/mon-profile/ajouter_avis/' + msg.i} className='btn brc4 brc2solid cl4 mr10 hover-cl1 hover-bg4'>Je laisse mon évaluation</Link>
                        </div>

                    }

                </>

            }

            {

                // Finalisé : Prestataire

                (msg.type == 38 && msg.s != me)

                &&

                <>

                    <div className='mt20'>

                        <p>Les gains seront bientôt transférés sur ton porte-monnaie. Vas sur ton profil Sisters Green et assure-toi que ton RIB soit à jour dans la section "PORTE-MONNAIE"</p>

                        { msg.stt == 1 && <p className='cl4 fz11 mt20' >Tu as reçu une nouvelle évaluation, découvre la !</p> }

                    </div>

                </>

            }

        </div>

    )

}

export { HeaderProfile, ProfileMenu, Article, DiscussionsCard, DiscussionCard, Message };